import { render, staticRenderFns } from "./HolidayConfig.vue?vue&type=template&id=694a1cba"
import script from "./HolidayConfig.vue?vue&type=script&lang=js"
export * from "./HolidayConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports